import axios from "axios";
const axiosWithCredentials = axios.create({ withCredentials: true });

export const REMOTE_SERVER = process.env.REACT_APP_REMOTE_SERVER;
export const USERS_API = `${REMOTE_SERVER}/api/users`;

export const signin = async (credentials: any) => {
  console.log("REMOTE_SERVER:", process.env.REACT_APP_REMOTE_SERVER);
    const response = await axiosWithCredentials.post( `${USERS_API}/signin`, credentials );
    return response.data;
};

export const signup = async (user: any) => {
    const response = await axiosWithCredentials.post(`${USERS_API}/signup`, user);
    return response.data;
};

export const updateUser = async (user: any) => {
    const response = await axiosWithCredentials.put(`${USERS_API}/${user._id}`, user);
    return response.data;
};

export const profile = async () => {
    const response = await axiosWithCredentials.post(`${USERS_API}/profile`); 
    return response.data;
};

export const signout = async () => {
    const response = await axiosWithCredentials.post(`${USERS_API}/signout`);
    return response.data;
};

export const findMyCourses = async () => {
    const { data } = await axiosWithCredentials.get(`${USERS_API}/current/courses`);
    return data;
};

export const createCourse = async (course: any) => {
    const { data } = await axiosWithCredentials.post(`${USERS_API}/current/courses`, course);
    return data;
};

export const findAllUsers = async () => {
  const response = await axiosWithCredentials.get(USERS_API);
  return response.data;
};

export const deleteUser = async (uid: String) => {
  const response = await axiosWithCredentials.delete(`${USERS_API}/${uid}`)
  return response.data;
}

export const findUserById = async (uid: String) => {
  const response = await axiosWithCredentials.get(`${USERS_API}/${uid}`)
  return response.data;
}

export const createUser = async (user: any) => {
  const response = await axiosWithCredentials.post(`${USERS_API}`, user)
  return response.data;
}
  
  
  
  
  
  
